var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignOutIcon = function SvgSignOutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19,
    fill: "none",
    viewBox: "0 0 22 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1818",
    d: "M2.735 13.14V5.354a2.657 2.657 0 0 1 2.656-2.654h7.22V.48h-7.22A4.88 4.88 0 0 0 .518 5.353v7.784a4.88 4.88 0 0 0 4.873 4.875h7.22v-2.22h-7.22a2.657 2.657 0 0 1-2.656-2.654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1818",
    d: "m22 9.248-7.903-6.875V4.85H5.596v8.796h8.5v2.477z"
  })));
};
export default SvgSignOutIcon;